import { useEffect, useState } from "react";
import { URL_API } from "../../utils/helper/helpers";
import axios from "axios";
import { toast } from "react-toastify";

interface FourInterface {
    [key: string]: any;
}

const useFourListe = (refresh: boolean): FourInterface[] => {
    const [fours, setFours] = useState<FourInterface[]>([]);
    const Token = JSON.parse(localStorage.getItem("login")!);

    useEffect(() => {
        const fetchFours = async () => {
            axios.get(`${URL_API}/fournisseur/all`, {
                headers: {
                    Authorization: `Bearer ${Token}`
                }
            }).then(response => {

                if (response.data.success) {
                    setFours(response.data.fournisseurs);
                }

            }).catch(error => {
                if (error.response.status === 400) {
                    toast.info(error.response.data.message);
                }

                if (error.response.status === 500) {
                    toast.warning(error.response.data.message);
                }
            })
        };

        fetchFours();
    }, [refresh]);
    return fours;
};
export default useFourListe;

export const deleteFours = async ({ id }: { id: number }, onSuccess: () => void) => {
    const Token = JSON.parse(localStorage.getItem("login")!);

    axios.post(`${URL_API}/fournisseur/delete/${id}`, {}, {
        headers: {
            Authorization: `Bearer ${Token}`
        }
    }).then(response => {

        if (response.data.success) {
            toast.warning("Élément Supprimer avec succès")
            onSuccess();
        }

    }).catch(error => {
        if (error.status === 405) {
            toast.info(error.response.data.message)
        }
        toast.info('Server Error')
    })

}

export const changeStatus = ({ id }: { id: number }, onSuccess: () => void) => {
    const Token = JSON.parse(localStorage.getItem("login")!);
    axios.post(`${URL_API}/fournisseur/block/${id}`, {}, {
        headers: {
            Authorization: `Bearer ${Token}`
        }
    }).then(response => {

        if (response.data.success) {
            toast.success("Status Changé avec success")
            onSuccess();
        }

    }).catch(error => {
        if (error.response.status === 405) {
            toast.info(error.response.data.message)
        }
    })

}